
define('ldsh!modules/lp_integration/templates/fields_step_empty_view', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<p data-i18n="integration.webserviceFieldsEmpty">No tienes formulario(s) en tu Landing Page.</p>\n';

}
return __p
};});

